import { useIntl } from 'react-intl';

import { FlexColumn, FlexRow } from 'ui-components/components/flex';
import { Text, TextType } from 'ui-components/components/text';

import EmptyBoxIcon from './empty-box-icon.svg';
import { messages } from '../messages';
import style from '../style.module.css';

export const EmptyCustomPackagesPlaceholder = () => {
  const intl = useIntl();

  return (
    <FlexColumn className={style['image-wrapper']}>
      <FlexRow>
        <img alt={intl.formatMessage(messages.altImageText)} src={EmptyBoxIcon} />
      </FlexRow>
      <FlexRow>
        <Text textType={TextType.H4} value={messages.emptyBoxMessage} />
      </FlexRow>
      <FlexRow>
        <Text textType={TextType.Paragraph} value={messages.emptyCustomPackagesInstructions} />
      </FlexRow>
    </FlexColumn>
  );
};
